import React from 'react'
import './styles.scss';
import { publisherRecircClick, publisherRecircScroll  } from '../../ctas';
import TrackedLink from '../TrackedLink/Element'
import GaImpressionTrigger from '../GaImpressionTrigger/Element';

const Publisher = ({name, logoUrl}) => (
    <React.Fragment>
      { logoUrl ? <img className="publisher-logo" src={logoUrl} alt={name}/> : null }
      <p className="title">More from {name}</p>
    </React.Fragment>
)

const RelatedItem = ({id, targetUrl, title, saveCount}, index) => {
  const ArticleLink = TrackedLink({...publisherRecircClick, index});

  return (
    <GaImpressionTrigger index={index} {...publisherRecircScroll} >
      <li className="article-item" key={id}>
        <ArticleLink href={targetUrl} className="outgoing-links-article-title" target="_blank">{title}</ArticleLink>
        <div className="pocket-saves-line">{saveCount.toLocaleString()} Saves</div>
      </li>
    </GaImpressionTrigger>
  );
}

export default ({relatedItems, publisher}) => {
  return (publisher && relatedItems.length > 0 &&
      <aside className="outgoing-links">
        <Publisher {...publisher} />
        <ul>
          {relatedItems.slice(0,3).map(RelatedItem)}
        </ul>
      </aside>
  )
};

